import { Button, Form, Modal, notification, Spin } from "antd";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { FormTextFormField } from "../../elements";
import { X } from "@phosphor-icons/react";
import { CustomLayerService } from "../../utility";

const UploadSchema = yup.object().shape({
  layer_key: yup.string().trim().required("Layer Key is required"),
  email: yup.string().email().required("Email is required"),
  substations_miles: yup
    .number()
    .typeError("Substations Miles must be a number")
    .required("Substations Miles is required"),
  substations_count: yup
    .number()
    .typeError("Substations Count must be a number")
    .required("Substations Count is required"),
  natural_gas_liquid_pipelines_miles: yup
    .number()
    .typeError("Must be a number")
    .required("Natural Gas Liquid Pipelines Miles is required"),
  natural_gas_liquid_pipelines_count: yup
    .number()
    .typeError("Must be a number")
    .required("Natural Gas Liquid Pipelines Count is required"),
  electric_power_transmission_lines_miles: yup
    .number()
    .typeError("Must be a number")
    .required("Electric Power Transmission Lines Miles is required"),
  electric_power_transmission_lines_count: yup
    .number()
    .typeError("Must be a number")
    .required("Electric Power Transmission Lines Count is required"),
  fiber_data_compacted_miles: yup
    .number()
    .typeError("Must be a number")
    .required("Fiber Data Compacted Miles is required"),
  fiber_data_compacted_count: yup
    .number()
    .typeError("Must be a number")
    .required("Fiber Data Compacted Count is required"),
});

export const CustomLayerModal = ({ open, closeModal, layerKey }) => {
  const [processing, setProcessing] = useState("");

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(UploadSchema),
    defaultValues: {
      layer_key: "new-layer",
    },
  });
  useEffect(() => {
    if (open) {
      reset({
        layer_key: layerKey,
      });
    }
  }, [open, reset, layerKey]);

  const save = async (userFormData) => {
    try {
      setProcessing(true);
      await CustomLayerService.request(userFormData);
      closeModal(true);
      notification.success({
        message: "Your Request for custom layer export is started",
      });
    } catch (error) {
      notification.error({
        message:
          error?.message ||
          "An unexpected error occurred. Please contact support for assistance.",
      });
    } finally {
      setProcessing("");
    }
  };

  return (
    <Modal
      open={open}
      title="Create Custom Layer"
      closeIcon={<X size={16} weight="bold" />}
      onCancel={() => closeModal()}
      width={600}
      footer={[
        <Button
          key="submit"
          type="primary"
          //   disabled={!isValid}
          loading={processing}
          onClick={handleSubmit(save)}
          block
        >
          Submit
        </Button>,
      ]}
    >
      <Spin spinning={!!processing}>
        <Form layout="vertical">
          <div className="row col-12">
            <FormTextFormField
              control={control}
              errors={errors?.email}
              name="email"
              required
              label="Email"
            />

            <FormTextFormField
              control={control}
              errors={errors?.substations_miles}
              name="substations_miles"
              required
              label="Substations Miles"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.substations_count}
              name="substations_count"
              required
              label="Substations Count"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.natural_gas_liquid_pipelines_miles}
              name="natural_gas_liquid_pipelines_miles"
              required
              label="Natural Gas Liquid Pipelines Miles"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.natural_gas_liquid_pipelines_count}
              name="natural_gas_liquid_pipelines_count"
              required
              label="Natural Gas Liquid Pipelines Count"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.electric_power_transmission_lines_miles}
              name="electric_power_transmission_lines_miles"
              required
              label="Electric Power Transmission Lines Miles"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.electric_power_transmission_lines_count}
              name="electric_power_transmission_lines_count"
              required
              label="Electric Power Transmission Lines Count"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.fiber_data_compacted_miles}
              name="fiber_data_compacted_miles"
              required
              label="Fiber Data Compacted Miles"
              className="col-6"
            />

            <FormTextFormField
              control={control}
              errors={errors?.fiber_data_compacted_count}
              name="fiber_data_compacted_count"
              required
              label="Fiber Data Compacted Count"
              className="col-6"
            />
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};
